import * as React from 'react';
import { drawSoundwave } from '../controller/utils';

interface Props {
  buffer: AudioBuffer;
  width: number;
  height: number;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  onMouseDown?: (e: React.MouseEvent<HTMLElement>) => void;
  onTouchStart?: (e: React.TouchEvent<HTMLElement>) => void;
}

class WaveformView extends React.Component<Props> {
  wrapper = React.createRef<HTMLCanvasElement>();

  renderCanvas() {
    const el = this.wrapper.current;
    if (el) {
      const ctx = el.getContext('2d')!;
      const { buffer, width, height } = this.props;
      drawSoundwave(ctx, buffer, width, height);
    }
  }

  componentDidMount() {
    this.renderCanvas();
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    const { buffer, width, height } = this.props;
    if (
      prevProps.buffer !== buffer ||
      prevProps.width !== width ||
      prevProps.height !== height
    ) {
      this.renderCanvas();
    }
  }

  render() {
    const { width, height, onClick, onMouseDown, onTouchStart } = this.props;
    return (
      <canvas
        width={width}
        height={height}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        ref={this.wrapper}
      />
    );
  }
}

export default WaveformView;



// WEBPACK FOOTER //
// ./src/audio/WaveformView.tsx